/** offset = serverTime − Date.now(), refreshed from every snapshot. */
export interface ServerClock { offset: number }

export function updateClock(_previous: ServerClock, serverTime: number, now = Date.now()): ServerClock {
  return { offset: serverTime - now };
}

export function remainingMs(deadline: number | null, clock: ServerClock, now = Date.now()): number | null {
  if (deadline === null) return null;
  return Math.max(0, deadline - (now + clock.offset));
}
